import type { DiffChange } from "@gaurussel/tiptap-diff-utility";
import type { Node } from "prosemirror-model";

const tabsAround = (doc: Node, pos: number): { node: Node; pos: number } | null => {
	if (pos < 0 || pos > doc.content.size) return null;
	const resolved = doc.resolve(pos);
	for (let depth = resolved.depth; depth > 0; depth--) {
		if (resolved.node(depth).type.name === "tabs")
			return { node: resolved.node(depth), pos: resolved.before(depth) };
	}
	return null;
};

const deletedTabEdits = (changes: DiffChange[], before: Node, after: Node): DiffChange[] => {
	const edited = new Set(changes.filter((change) => change.type === "modified").map((change) => change.posB));
	const added: DiffChange[] = [];

	for (const change of changes) {
		if (change.type !== "deleted" || change.nodeA?.type.name !== "tab" || change.posA === undefined) continue;
		const oldTabs = tabsAround(before, change.posA);
		const newTabs = change.from === undefined ? null : tabsAround(after, change.from);
		if (!oldTabs || !newTabs || edited.has(newTabs.pos)) continue;
		edited.add(newTabs.pos);
		added.push({
			type: "modified",
			from: newTabs.pos,
			to: newTabs.pos + newTabs.node.nodeSize,
			nodeA: oldTabs.node,
			posA: oldTabs.pos,
			nodeB: newTabs.node,
			posB: newTabs.pos,
		});
	}

	if (!added.length) return changes;
	const order = (change: DiffChange) => change.from ?? change.posB ?? 0;
	return [...changes, ...added].sort((left, right) => order(left) - order(right));
};

export default deletedTabEdits;
